import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaCreditCard } from 'react-icons/fa';
import FinancingExceptionPage from 'Modules/fortiva/components/FinancingExceptionPage';

export default function FinancingAlreadyProcessed() {
  const { t } = useTranslation();

  return (
    <FinancingExceptionPage
      pageTitle={t('fortiva.alreadyProcessed.pageTitle', 'Payment Portal - Application Processed')}
      icon={FaCheckCircle}
      testId="title-already-processed"
      gradientClass="from-emerald-500 to-teal-500"
      subtitleColorClass="text-emerald-100"
      badgeClass="bg-emerald-100 text-emerald-700"
      title={t('fortiva.alreadyProcessed.title', 'This application has already been processed')}
      subtitle={t(
        'fortiva.alreadyProcessed.subtitle',
        'It looks like an account already exists for this customer.'
      )}
      description={
        <>
          <p className="font-medium text-gray-800 !mb-2">Thank You for your Interest!</p>
          <p className="!mb-0">
            Our systems indicate that you have an existing Fortiva Retail Credit account.
          </p>
        </>
      }
      infoCard={{
        icon: FaCreditCard,
        iconBgColor: 'bg-emerald-50',
        iconColor: 'text-emerald-600',
        title: 'View your virtual card',
        description: (
          <>
            To view your credit card account number, please visit{' '}
            <a
              href="https://www.myfortiva.com/my-account"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-medium underline"
            >
              www.myfortiva.com/my-account
            </a>{' '}
            and select “View Virtual Card.”
          </>
        ),
      }}
    />
  );
}
